import * as squint_core from 'squint-cljs/core.js';
import { h, render } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import * as dom from './cljdoc.client.dom.jsx';
import * as cljdoc_DOT_client_DOT_dom from './cljdoc.client.dom.jsx';
import * as lib from './cljdoc.client.library.jsx';
import * as cljdoc_DOT_client_DOT_library from './cljdoc.client.library.jsx';
import { ListSearch } from './cljdoc.client.list-search.jsx';
import * as cljdoc_DOT_client_DOT_list_search from './cljdoc.client.list-search.jsx';
import * as str from 'squint-cljs/src/squint/string.js';
import * as clojure_DOT_string from 'squint-cljs/src/squint/string.js';
var is_same_project = function (p1, p2) {
if ((squint_core.get(p1, "group-id") === squint_core.get(p2, "group-id"))) {
return (squint_core.get(p1, "artifact-id") === squint_core.get(p2, "artifact-id"))} else {
return false};

};
var load_prev_opened = function () {
return JSON.parse((() => {
const or_1_2 = localStorage.getItem("previously_opened");
if (squint_core.truth_(or_1_2)) {
return or_1_2} else {
return "[]"};

})());

};
var is_error_page_QMARK_ = function () {
return document.querySelector("head > title[data-error]");

};
var track_project_opened = function () {
if (squint_core.not(is_error_page_QMARK_())) {
const max_track_count_1 = 15;
const project_2 = lib.coords_from_current_loc();
if (squint_core.truth_(project_2)) {
const prev_opened_3 = squint_core.vec(squint_core.remove((function (_PERCENT_1_SHARP_) {
return is_same_project(project_2, _PERCENT_1_SHARP_);

}), load_prev_opened()));
const dated_project_4 = squint_core.assoc(project_2, "last_viewed", (new Date()).toUTCString());
const __5 = prev_opened_3.push(dated_project_4);
const prev_opened_6 = squint_core.vec(squint_core.take(max_track_count_1, prev_opened_3));
return localStorage.setItem("previously_opened", JSON.stringify(prev_opened_6));
};
};

};
var RowView = function (p__11337) {
const map___1_3 = p__11337;
const map___1_4 = ((squint_core.truth_(squint_core.sequential_QMARK_(map___1_3))) ? (((squint_core.truth_(squint_core.vector_QMARK_(map___1_3))) ? (map___1_3) : (squint_core.seq_to_map_for_destructuring(map___1_3)))) : (map___1_3));
const result_5 = squint_core.get(map___1_4, "result");
const isSelected_6 = squint_core.get(map___1_4, "isSelected");
const selectResult_7 = squint_core.get(map___1_4, "selectResult");
const uri_8 = lib.docs_path(result_5);
const row_class_9 = ((squint_core.truth_(isSelected_6)) ? ("pa3 bb b--light-gray bg-light-blue") : ("pa3 bb b--light-gray"));
return <><a class="no-underline black" href={uri_8} onMouseOver={selectResult_7}><div class={row_class_9}><h4 class="dib ma0">{lib.project(result_5)}<span class="ml2 gray normal">{squint_core.get(result_5, "version")}</span></h4><a class="link blue ml2" href={uri_8}>view docs</a></div></a></>;

};
var load_recently_visited_docs = function () {
const G__11338_1 = load_prev_opened();
const G__11338_2 = (((G__11338_1 == null)) ? (null) : (squint_core.mapv((function (p__11339) {
const map___3_5 = p__11339;
const map___3_6 = ((squint_core.truth_(squint_core.sequential_QMARK_(map___3_5))) ? (((squint_core.truth_(squint_core.vector_QMARK_(map___3_5))) ? (map___3_5) : (squint_core.seq_to_map_for_destructuring(map___3_5)))) : (map___3_5));
const p_7 = map___3_6;
const artifact_id_8 = squint_core.get(map___3_6, "artifact-id");
const group_id_9 = squint_core.get(map___3_6, "group-id");
return squint_core.assoc(p_7, "project-id", ((squint_core._EQ_(group_id_9, artifact_id_8)) ? (group_id_9) : (`${group_id_9??''}${"/"}${artifact_id_8??''}`)));

}), G__11338_1)));
const G__11338_10 = (((G__11338_2 == null)) ? (null) : (squint_core.reverse(G__11338_2)));
if ((G__11338_10 == null)) {
return null} else {
return squint_core.vec(G__11338_10)};

};
var Switcher = function () {
const recently_visited_docs_7 = load_recently_visited_docs();
const vec___1_8 = useState(recently_visited_docs_7);
const results_9 = squint_core.nth(vec___1_8, 0, null);
const set_results_BANG__10 = squint_core.nth(vec___1_8, 1, null);
const vec___4_11 = useState(false);
const show_12 = squint_core.nth(vec___4_11, 0, null);
const set_show_BANG__13 = squint_core.nth(vec___4_11, 1, null);
const background_node_14 = useRef(null);
const is_macos_QMARK__15 = (str.upper_case(navigator.platform).indexOf("MAC") >= 0);
const reset_state_16 = (function () {
return set_results_BANG__10(recently_visited_docs_7);

});
const on_global_key_down_17 = (function (p__11340) {
const map___18_20 = p__11340;
const map___18_21 = ((squint_core.truth_(squint_core.sequential_QMARK_(map___18_20))) ? (((squint_core.truth_(squint_core.vector_QMARK_(map___18_20))) ? (map___18_20) : (squint_core.seq_to_map_for_destructuring(map___18_20)))) : (map___18_20));
const e_22 = map___18_21;
const key_23 = squint_core.get(map___18_21, "key");
const metaKey_24 = squint_core.get(map___18_21, "metaKey");
const ctrlKey_25 = squint_core.get(map___18_21, "ctrlKey");
if (squint_core.truth_(((("k" === key_23)) && ((() => {
const or_26_27 = ((is_macos_QMARK__15) ? (metaKey_24) : (is_macos_QMARK__15));
if (squint_core.truth_(or_26_27)) {
return or_26_27} else {
if (!is_macos_QMARK__15) {
return ctrlKey_25} else {
return false}};

})())))) {
e_22.preventDefault();
if (squint_core.truth_(squint_core.seq(recently_visited_docs_7))) {
set_show_BANG__13(true);
return set_results_BANG__10(recently_visited_docs_7);
};
} else {
if (("Escape" === key_23)) {
set_show_BANG__13(false);
return set_results_BANG__10([]);
} else {
return null}};

});
const update_results_28 = (function (search_str) {
const search_tokens_29 = str.split(str.lower_case(search_str), / +/);
if (squint_core.truth_(squint_core.seq(search_tokens_29))) {
return set_results_BANG__10(squint_core.filterv((function (p__11341) {
const map___30_32 = p__11341;
const map___30_33 = ((squint_core.truth_(squint_core.sequential_QMARK_(map___30_32))) ? (((squint_core.truth_(squint_core.vector_QMARK_(map___30_32))) ? (map___30_32) : (squint_core.seq_to_map_for_destructuring(map___30_32)))) : (map___30_32));
const project_id_34 = squint_core.get(map___30_33, "project-id");
const project_id_35 = str.lower_case(project_id_34);
return squint_core.every_QMARK_((function (_PERCENT_1_SHARP_) {
return str.includes_QMARK_(project_id_35, _PERCENT_1_SHARP_);

}), search_tokens_29);

}), recently_visited_docs_7))} else {
return reset_state_16()};

});
useEffect((function () {
return document.addEventListener("keydown", on_global_key_down_17);

}), []);
if (squint_core.truth_(show_12)) {
return <><div class="bg-black-30 fixed top-0 right-0 bottom-0 left-0 sans-serif" ref={background_node_14} onClick={(function (e) {
if (squint_core._EQ_(e.target, background_node_14.current)) {
return set_show_BANG__13(false);
};

})}><div class="mw7 center mt6 bg-white pa3 br2 shadow-3"><ListSearch show={show_12} initialValue="" place-holder-text="Jump to recently viewed docs..." results={results_9} rowView={RowView} resultsFetcher={update_results_28} onActivateItem={(function (item) {
return window.open(lib.docs_path(item), "_self");

})}></ListSearch></div></div></>;
};

};
var init = function () {
track_project_opened();
const temp__6897__auto___1 = dom.query("[data-id='cljdoc-switcher']");
if (squint_core.truth_(temp__6897__auto___1)) {
const switcher_node_2 = temp__6897__auto___1;
return render(h(Switcher), switcher_node_2);
};

};

export { init }
